import * as BABYLON from '@babylonjs/core/Legacy/legacy';
import { AdvancedDynamicTexture, Rectangle } from '@babylonjs/gui/2D';

import { GameScene } from '../scene.js';
import { Particle2D, YellowCoin2D } from './particle.js';
import { CoinPannel } from './coinPannel';
import { EndText } from './endText'
import { IElement2D } from './element.js';

const log = console.log.bind(console);


export class Scene2D {
    private gameScene: GameScene;
    private advancedTexture: AdvancedDynamicTexture;

    private elements: IElement2D[];
    private particles: Particle2D[];
    private coinPannel: CoinPannel;

    constructor(gameScene: GameScene, particles: Particle2D[]) {
        this.gameScene = gameScene;
        this.advancedTexture = AdvancedDynamicTexture.CreateFullscreenUI("UI");

        this.particles = particles;
        this.elements = [];

        this.coinPannel = new CoinPannel()
        this.addElement(this.coinPannel)

        let self = this
    }

    private updateParticles() {
        for (let i = 0; i < this.particles.length; i++) {
            const p = this.particles[i];
            p.update()
        }

        // 去除 die 的元素
        let i = 0
        while (i < this.particles.length) {
            const p = this.particles[i];
            if (p.getIsDie()) {
                p.dispose()
                this.particles.splice(i, 1)
                continue
            }
            i += 1
        }
    }

    private updateElements() {
        for (let i = 0; i < this.elements.length; i++) {
            const e = this.elements[i]
            e.update()
        }
    }

    update() {
        this.updateParticles()
        this.updateElements()
    }

    addElement(ele: IElement2D) {
        this.elements.push(ele)

        // 加入到 advancedTexture 才会被显示
        let controls = ele.getControls()
        for (let i = 0; i < controls.length; i++) {
            const c = controls[i];
            this.advancedTexture.addControl(c)
        }
    }

    addParticle(p: Particle2D) {
        // 加入到 advancedTexture 才会被显示
        this.advancedTexture.addControl(p.getControl())
        this.particles.push(p)
    }

    addCoinParticle() {
        let p = new YellowCoin2D()
        this.addParticle(p)
    }

    end() {
        this.addElement(new EndText())
    }
}